import { Button, Header, Icon, Modal } from '@mairistem/composants';
import _ from 'lodash';

import type { FactureType } from '@/types';

interface ModalFactureDejaPayeeProps {
  // Factures sélectionnées dont MFO déclare le paiement en ligne.
  factures: FactureType[];
  onClose: () => void;
}

/**
 * Blocage de l'encaissement : une des factures sélectionnées a été payée en ligne.
 *
 * Volontairement sans bouton « Continuer » — contrairement à une confirmation, il n'y a pas de
 * choix à laisser au régisseur : encaisser une facture déjà réglée créerait un doublon de
 * paiement. Il ferme, décoche la facture concernée, et revalide.
 *
 * Aucun montant n'est affiché : l'unité du montant renvoyé par MFO n'est pas documentée.
 */
const ModalFactureDejaPayee = (props: ModalFactureDejaPayeeProps) => {
  const { factures, onClose } = props;

  const plusieurs = factures.length > 1;

  return (
    <Modal open size="tiny" onClose={onClose}>
      <Modal.Header>
        <Icon name="warning sign" style={{ fontSize: '1.25em' }} />
        {plusieurs ? 'Factures déjà payées en ligne' : 'Facture déjà payée en ligne'}
      </Modal.Header>
      <Modal.Content>
        {plusieurs
          ? "Vous ne pouvez pas encaisser ces factures : elles ont été payées en ligne et il n'y a plus rien à payer."
          : "Vous ne pouvez pas encaisser cette facture : elle a été payée en ligne et il n'y a plus rien à payer."}
        <Header as="h4">
          <Header.Content>
            <br />
            {_.map(factures, (facture) => (
              <div key={facture.identifiant} data-testid="facture-deja-payee">
                {facture.numero}
              </div>
            ))}
            <Header.Subheader>
              <br />
              {plusieurs
                ? 'Décochez-les pour poursuivre votre encaissement.'
                : 'Décochez-la pour poursuivre votre encaissement.'}
            </Header.Subheader>
          </Header.Content>
        </Header>
      </Modal.Content>
      <Modal.Actions>
        <Button
          data-testid="button-close-facture-deja-payee"
          onClick={onClose}
          basic
          content="Fermer"
        />
      </Modal.Actions>
    </Modal>
  );
};

export default ModalFactureDejaPayee;
